import { render, staticRenderFns } from "./modal-contact.vue?vue&type=template&id=8181cc36&"
import script from "./modal-contact.vue?vue&type=script&lang=js&"
export * from "./modal-contact.vue?vue&type=script&lang=js&"
import style0 from "./modal-contact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports